module.exports = __webpack_public_path__ + "static/media/slide4.1b05f841.png";